<template>
	<div class="employee-container"
			 :class="visible ? 'visible-transition transition-delay-'+delay+'' : 'invisible-transition'">
		<div class="employee-inner-container">
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.france }">
					<span class="precentage">28%</span>
				</div>
				<div class="country">
					<span>France</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.sweden }">
					<span class="precentage">14%</span>
				</div>
				<div class="country">
					<span>Sweden</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.us }">
					<span class="precentage">12%</span>
				</div>
				<div class="country">
					<span>US</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.germany }">
					<span class="precentage">9%</span>
				</div>
				<div class="country">
					<span class="small">Germany</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.italy }">
					<span class="precentage">9%</span>
				</div>
				<div class="country">
					<span>Italy</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.brazil }">
					<span class="precentage">6%</span>
				</div>
				<div class="country">
					<span>Brazil</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.china }">
					<span class="precentage">5%</span>
				</div>
				<div class="country">
					<span>China</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.finland }">
					<span class="precentage">5%</span>
				</div>
				<div class="country">
					<span>Finland</span>
				</div>
			</div>
			<div class="employee-table-cell">
				<img src="../assets/img/icons/employee.svg">
				<div class="employee-stacks transition-height"
						 :style="{ height: value.other }">
					<span class="precentage">12%</span>
				</div>
				<div class="country">
					<span>Other</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
	    visible: {
        default: () => false
	    },
	    delay: {
        default: () => 0
	    }
		},
		data() {
			return {
				value: {
					france: 	'0%',
				  sweden: 	'0%',
				  us: 			'0%',
				  germany: 	'0%',
				  italy: 		'0%',
				  brazil: 	'0%',
				  china: 		'0%',
				  finland: 	'0%',
				  other: 		'0%'
				}
			}
		},
		watch: {
			visible: function(val) {
				//to fit in container the max-height value is 76%
			  if(val) {
				  setTimeout(function() {
						  this.value.france 	= '56%';
						  this.value.sweden 	= '28%';
						  this.value.us 			= '24%';
						  this.value.germany 	= '18%';
						  this.value.italy 		= '18%';
						  this.value.brazil 	= '12%';
						  this.value.china 		= '10%';
						  this.value.finland 	= '10%';
						  this.value.other 		= '24%';
					  }.bind(this), this.delay);
			  }else{
				  this.value.france 	= '0%';
				  this.value.sweden 	= '0%';
				  this.value.us 			= '0%';
				  this.value.germany 	= '0%';
				  this.value.italy 		= '0%';
				  this.value.brazil 	= '0%';
				  this.value.china 		= '0%';
				  this.value.finland 	= '0%';
				  this.value.other 		= '0%';
			  }
		  }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Employees.vue